module.exports = __webpack_public_path__ + "static/media/vri.419d9580.m4a";